import { render, staticRenderFns } from "./CustomerLayers.vue?vue&type=template&id=6deafef4&scoped=true&"
import script from "./CustomerLayers.vue?vue&type=script&lang=js&"
export * from "./CustomerLayers.vue?vue&type=script&lang=js&"
import style0 from "./CustomerLayers.vue?vue&type=style&index=0&id=6deafef4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6deafef4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})
